import { create } from "zustand";
import { devtools } from "zustand/middleware";
import http from "@/lib/http";
import { toast } from "sonner";

const useHistoryStore = create(
  devtools((set) => ({
    loading: false,
    error: null,
    transactions: [],
    billingHistory: [],

    getTransactions: async (isUser, id) => {
      set({ loading: true, error: null });
      try {
        const { data } = isUser
          ? await http.get("wallet/billing-history")
          : await http.get(`/public/property/transactions/${id}`);
        set({ transactions: data.result, loading: false });
        return data;
      } catch (error) {
        const errorMessage =
          error?.response?.data?.message || "Failed to fetch transactions";
        set({ error: errorMessage, loading: false });
        toast.error(errorMessage);
      }
    },

    getStripeBillingHistory: async (customerId) => {
      set({ loading: true, error: null });
      try {
        const { data } = await http.get(
          `/payment/billing-history/${customerId}`,
        );
        set({ billingHistory: data?.billingHistory, loading: false });
        return data;
      } catch (error) {
        const errorMessage =
          error?.response?.data?.message ||
          "Failed to fetch Stripe billing history";
        set({ error: errorMessage, loading: false });
        toast.error(errorMessage);
      }
    },
  })),
);

export default useHistoryStore;
